import React, { Fragment, useEffect } from 'react';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DefaultContain from 'Component/DashboardQeza/Product';

const Product = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <Breadcrumbs parent="Produk" title="Daftar Produk" />
            <DefaultContain />
        </Fragment>
    );
};
export default Product;